<template>
    <div class="dropdown" :tabindex="tabindex" @blur="open = false">
        <Field type="text" hidden :name="name" v-model="sortValue"/>
        <div class="dropdown__selected" @click="open = !open">
            <div class="dropdown__selected-label">
                <slot :labelObject="options[sort]">{{ options[sort] }}</slot>
            </div>
            <i v-if="open" class="fas fa-chevron-up dropdown__chevron"></i>
            <i v-else class="fas fa-chevron-down dropdown__chevron"></i>
        </div>
        <div v-show="open" class="dropdown__items">
            <div v-for="option of sortedOptions" class="dropdown__item"
                 :key="option.value"
                 @click="updateValue(option.value)">
                <slot :labelObject="option.label">{{ option.label }}</slot>
            </div>
        </div>
    </div>
</template>

<script>
import {Field} from "vee-validate";
import {ref} from "vue";

export default {
    name: 'Dropdown',
    components: {Field},
    emits: ['update:sort'],
    props: {
        name: {
            type: String,
            required: true,
        },
        // Options is an object of {1: 'a', 2: 'b'} format where 'a', 'b' are
        // displayed as labels in dropdown and 1, 2 are used as values
        options: {
            type: Object,
            required: true,
        },
        // Array of Option keys to set their order ex. [2, 1] displays 'b' then 'a'
        optionsOrder: {
            type: Array,
            required: false,
            default: null,
        },
        sort: {
            type: [String, Number],
            required: false,
            default: null,
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0,
        }
    },
    setup(props) {
        const sortValue = ref(props.sort)
        const open = ref(false)


        return {
            sortValue,
            open,
        }

    },
    computed: {
        sortedOptions() {
            let sortedOptions = []
            if (this.optionsOrder !== null) {
                for (const value of this.optionsOrder) {
                    if (value in this.options) {
                        sortedOptions.push({'label': this.options[value], 'value': value})
                    }
                }
            } else {
                for (const [value, label] of Object.entries(this.options)) {
                    sortedOptions.push({'label': label, 'value': value})
                }
            }
            return sortedOptions;
        },
    },
    methods: {
        updateValue(value) {
            this.open = false;
            this.$emit('update:sort', value);
            this.sortValue = value
        }
    }
}
</script>